<!-- src/components/IndOverviewSum.vue -->
<template>
  <div class="p-4 border-radius-8 border-brown-300 border-radius">
    <div class="font-weight-bold s-24 text-head mb-4">
      Other Asset information
    </div>
    <div class="row">
      <div
        class="col-md-6 mb-3"
        v-for="(item, index) in assetInfo"
        :key="index"
      >
        <div class="row align-items-center">
          <div class="col-md-5 s-18 text-right fw-400">{{ item.label }}:</div>
          <div class="bg-light2 col-md-7 p-2 rounded">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import monthDayYear from "../../../services/dates/dateformatter";
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const statusOptions = ref([
  "Available",
  "InUse",
  "UnderMaintenance",
  "InUse",
  "Retired",
]);
const conditionOptions = ref(["New", "Used", "Refurbished", "Damaged"]);

const date = (offDate) => {
  return monthDayYear.monthDayYear(offDate);
};

const assetInfo = computed(() => {
  if (!props.data) return [];

  return [
    { label: "Asset Code", value: props.data.assetCode || "" },
    { label: "Manufacturer", value: props.data.manufacturer || "" },
    { label: "Model/Version", value: props.data.modelVersion || "" },
    {
      label: "Purchase Date",
      value: props.data.dateOfPurchase ? date(props.data.dateOfPurchase) : "",
    },
    {
      label: "Purchase Price",
      value: props.data.amount
        ? Math.round(props.data.amount).toLocaleString()
        : "",
    },
    { label: "Warranty", value: props.data.warranty || "" },
    { label: "Physical Location", value: props.data.location || "" },
    // {
    //   label: "Assigned Dept",
    //   value: props && props.data ? props.data.assetCode : "",
    // },
    // {
    //   label: "Assigned User",
    //   value: props && props.data ? props.data.assetCode : "",
    // },
    {
      label: "Status",
      value: statusOptions.value[props.data.status] || "",
    },
    {
      label: "Condition",
      value: conditionOptions.value[props.data.condition] || "",
    },
    {
      label: "Depreciation %",
      value: props.data.depreciationRate || "",
    },
  ];
});
</script>

<style scoped>
.bg-light2 {
  background-color: #edf4ff;
}
</style>
